function initSamplStates($stateProvider) {

	$stateProvider.state(
			'home.planSamplingMenu',
			{
				url : "/plansampling/create",
				templateUrl : "views/sampl/planSampling.detail.html",
				data : {
					type : 'create',
					permissions : {
						only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.CLIENT.code, ROLE_TYPE.TECHNICAL_PROFESSIONAL.code, ROLE_TYPE.PROGRAMMING_COORDINATOR.code, ROLE_TYPE.SAMPLE_RECEIVER.code,
								ROLE_TYPE.SAMPLES_PROFESSIONAL.code, ROLE_TYPE.LABORATORY_PROFESSIONAL.code, ROLE_TYPE.ACCOUNTING.code ]
					}
				}
			}).state('home.planSamplingCreate', {
		url : "/plansampling/create",
		templateUrl : "views/sampl/planSampling.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.planSamplingList', {
		url : "/plansampling/list",
		templateUrl : "views/sampl/planSampling.list.html",
		data : {
			type : 'search',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.CLIENT.code, ROLE_TYPE.TECHNICAL_PROFESSIONAL.code, ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.planSamplingUpdate', {
		url : "/plansampling/:id/update",
		templateUrl : "views/sampl/planSampling.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.planSamplingClone', {
		url : "/plansampling/:id/clone",
		templateUrl : "views/sampl/planSampling.detail.html",
		data : {
			type : 'clone',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.planSamplingStart', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.planSamplingCancel', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.planSamplingHome', {
		url : '/plansampling/:id/home',
		templateUrl : "views/sampl/planSampling.home.html",
		controller : "planSamplingHomeCtrl",
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.CLIENT.code, ROLE_TYPE.TECHNICAL_PROFESSIONAL.code, ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.samplingCreate', {
		url : '/plansampling/:idPlan/sampling/create',
		templateUrl : "views/sampl/sampling.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.samplingUpdate', {
		url : '/plansampling/:idPlan/sampling/:idSampling/update',
		templateUrl : "views/sampl/sampling.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.samplingRemove', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.cloneSample', {
		data : {
			permissions : {
				only : [  ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.samplingHome', {
		url : '/plansampling/:idPlan/sampling/:idSampling/home',
		templateUrl : "views/sampl/sampling.home.html",
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.cancelSample', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code]
			}
		}
	}).state('home.sampleCreate', {
		url : '/plansampling/:idPlan/sampling/:idSampling/product/:idProduct/sample/create',
		templateUrl : "views/sampl/sample.detail.html",
		controller : 'sampleDetailCreateCtrl',
		controllerAs : 'ctrl',
		data : {
			type : 'add',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.sampleUpdate', {
		url : '/plansampling/:idPlan/sampling/:idSampling/product/:idProduct/sample/:idSample/update',
		templateUrl : "views/sampl/sample.detail.html",
		controller : 'sampleDetailUpdateCtrl',
		controllerAs : 'ctrl',
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.sampleHome', {
		url : '/plansampling/:idPlan/sampling/:idSampling/sample/:idSample/home',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.header.html"
			},
			'sampleState@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.sampleState.html"
			},
			'nonConforming@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.nonConforming.html"
			},
			'planSampling@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.planSampling.html"
			},
			'visitInfo@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.visitInfo.html"
			},
			'schedule@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.scheduling.html"
			},
			'takeInfo@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'analysisResult@home.sampleHome' : {
				templateUrl : "views/sampl/sample.home/sample.home.analysisResults.html"
			}
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'planSampling',
					name : 'Plan de Muestreo'
				}, {
					href : 'visitInfo',
					name : 'Datos visita'
				}, {
					href : 'schedule',
					name : 'Programación'
				}, {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Análisis'
				} ];
			},
			stepsResolve : function(sampleDataResolve) {
				var states = [ {
					name : SAMPLE_STATE.SCHEDULED.name,
					index : 0
				}, {
					name : SAMPLE_STATE.ASIGNED.name,
					index : 1
				}, {
					name : SAMPLE_STATE.TAKEN.name,
					index : 2
				}, {
					name : SAMPLE_STATE.ADMITED.name,
					index : 3
				}, {
					name : SAMPLE_STATE.ANALYZED.name,
					index : 4
				}, {
					name : SAMPLE_STATE.REPORTED.name,
					index : 5
				} ];

				if (sampleDataResolve != null && angular.isDefined(sampleDataResolve)) {
					if (sampleDataResolve.getData().state == SAMPLE_STATE.ANALYZING.enumName) {
						states[4].name = SAMPLE_STATE.ANALYZING.name;
					}
				}

				return states;
			},
			showAnalysisResultsResolve : function() {
				return true;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.PROGRAMMING_COORDINATOR.code ]
			}
		}
	}).state('home.sampleSchedule', {
		url : '/sample/schedule?idClient&states&page&start&end&tag&site&area&idplan&sampleId',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.schedule/sample.schedule.html",
				controller : 'sampleScheduleCtrl',
				controllerAs : 'ctrl',
			},
			'filters@home.sampleSchedule' : {
				templateUrl : "views/sampl/sample.schedule/sample.schedule.filters.html",
				controller : 'sampleScheduleFiltersCtrl',
				controllerAs : 'ctrlflt'
			},
			'list@home.sampleSchedule' : {
				templateUrl : "views/sampl/sample.schedule/sample.schedule.list.html",
			},
			'calendar@home.sampleSchedule' : {
				templateUrl : "views/sampl/sample.schedule/sample.schedule.calendar.html",
				controller : 'sampleScheduleCalendarCtrl',
				controllerAs : 'ctrlCal'
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.PROGRAMMING_COORDINATOR.code ]
			}
		}
	}).state('home.grid', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.EditTakeSample', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.sampleAnalyzeEdit', {
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.professionalSamplingTask', {
		url : '/professionalSampling/task?sampleId&idClient&states&page',
		templateUrl : "views/sampl/sample.task/professionalSampling.task.html",
		controller : 'professionalSamplingTaskCtrl',
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.professionalSamplingTask.signsampling', {
		url : '/professionalSampling/signsampling',
		templateUrl : "views/sampl/sample.task/sample.task.sign.form.html",
		controller : 'sampleSignFormCtrl',
		controllerAs : 'ctrl',
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.professionalSamplingTask.sample', {
		url : '/sample',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.header.html"
			},
			'sampleState@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.sampleState.html"
			},
			'nonConforming@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.nonConforming.html"
			},
			'planSampling@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.planSampling.html"
			},
			'visitInfo@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.visitInfo.html"
			},
			'schedule@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.scheduling.html"
			},
			'sampleElements@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.task/sample.task.samplingElements.html",
				controller : 'sampleTaskElementCtrl',
				controllerAs : 'ctrlEl',
			},
			'takeInfo@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'takeForm@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.task/sample.task.takeInfo.html",
				controller : 'sampleTaskTakeFormCtrl',
				controllerAs : 'ctrlTk',
			},
			'analysisResult@home.professionalSamplingTask.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.analysisResults.html"
			}
		},
		params : {
			idPlan : null,
			idSampling : null,
			idSample : null
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				if (!$stateParams.idSample)
					return null;
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'visitInfo',
					name : 'Datos visita'
				}, {
					href : 'schedule',
					name : 'Programación'
				}, {
					href : 'sampleElements',
					name : 'Elementos de Muestreo'
				}, {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Análisis'
				} ];
			},
			stepsResolve : function() {
				return [ {
					name : SAMPLE_STATE.ASIGNED.name,
					index : 1
				}, {
					name : SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED.name,
					index : 2
				}, {
					name : SAMPLE_STATE.TAKEN.name,
					index : 3
				} ];
			},
			showAnalysisResultsResolve : function() {
				return false;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.SAMPLES_PROFESSIONAL.code ]
			}
		}
	}).state('home.sampleReceive', {
		url : '/sampleReceive?sampleId&idClient&states&page&start&end&userid',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home.detail/sample.home.detail.html",
				controller : 'sampleReceiveCtrl',
			},
			'filters@home.sampleReceive' : {
				templateUrl : "views/sampl/sample.receive/sample.receive.detail.filter.html",
				controller : 'sampleReceiveFilterCtrl'
			},
			'list@home.sampleReceive' : {
				templateUrl : "views/sampl/sample.receive/sample.receive.detail.list.html",
			}
		},
		resolve : {
			urlSampleDetail : function() {
				return 'home.sampleReceive.sample'
			}
		},
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.SAMPLE_RECEIVER.code ]
			},
		    title: 'Recepción de muestras'
		}
	}).state('home.sampleReceive.sample', {
		url : '/sample',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.header.html"
			},
			'sampleState@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.sampleState.html"
			},
			'nonConforming@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.nonConforming.html"
			},
			'planSampling@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.planSampling.html"
			},
			'visitInfo@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.visitInfo.html"
			},
			'schedule@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.scheduling.html"
			},
			'takeInfo@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'takeForm@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.receive/sample.receive.takeForm.html",
				controller : 'sampleReceiveTakeFormCtrl',
				controllerAs : 'ctrlTk',
			},
			'analysisResult@home.sampleReceive.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.analysisResults.html"
			}
		},
		params : {
			idPlan : null,
			idSampling : null,
			idSample : null
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				if (!$stateParams.idSample)
					return null;
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'planSampling',
					name : 'Plan de Muestreo'
				}, {
					href : 'visitInfo',
					name : 'Datos visita'
				}, {
					href : 'schedule',
					name : 'Programación'
				}, {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Análisis'
				} ];
			},
			stepsResolve : function() {
				return [ {
					name : SAMPLE_STATE.SCHEDULED.name,
					index : 0
				}, {
					name : SAMPLE_STATE.ASIGNED.name,
					index : 1
				}, {
					name : SAMPLE_STATE.TAKEN.name,
					index : 2
				}, {
					name : SAMPLE_STATE.ADMITED.name,
					index : 3
				} ]
			},
			showAnalysisResultsResolve : function() {
				return false;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.SAMPLE_RECEIVER.code ]
			}
		}
	}).state('home.sampleAnalyze', {
		url : '/sampleAnalyze?sampleId&states&page&start&end&userid',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home.detail/sample.home.detail.html",
				controller : 'sampleAnalyzeCtrl',
			},
			'filters@home.sampleAnalyze' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.detail.filter.html",
				controller : 'sampleAnalyzeFilterCtrl'
			},
			'list@home.sampleAnalyze' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.detail.list.html"
			},
			'analyzeReport@home.sampleAnalyze' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.detail.report.html"
			}
		},
		resolve : {
			urlSampleDetail : function() {
				return 'home.sampleAnalyze.sample'
			}
		},
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.LABORATORY_PROFESSIONAL.code ]
			},
			title: 'Análisis de muestras'
		}
	}).state('home.sampleAnalyze.sample', {
		url : '/sample',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.header.html"
			},
			'sampleState@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.sampleState.html"
			},
			'nonConforming@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.nonConforming.html"
			},
			'takeInfo@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'analysisResult@home.sampleAnalyze.sample' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.analysisResults.html",
				controller : 'sampleAnalysisResultCtrl',
				controllerAs : 'ctrlAR'
			}
		},
		params : {
			idPlan : null,
			idSampling : null,
			idSample : null
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				if (!$stateParams.idSample)
					return null;
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Análisis'
				} ];
			},
			stepsResolve : function() {
				return [ {
					name : SAMPLE_STATE.ADMITED.name,
					index : 0
				}, {
					name : SAMPLE_STATE.ANALYZING.name,
					index : 1
				}, {
					name : SAMPLE_STATE.ANALYZED.name,
					index : 2
				} ]
			},
			showAnalysisResultsResolve : function() {
				return true;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.LABORATORY_PROFESSIONAL.code ]
			},
			title: 'Análisis de muestras'
		}
	}).state('home.sampleLine', {
		url : '/planSampling/:idPlan/sampling/:idSampling/sample/:idSample/line',
		templateUrl : "views/sampl/sample.line/sample.line.html",
		controller : 'sampleLineCtrl',
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				return planSamplingService.getLineSample($stateParams.idSample);
			}
		},
		data : {
			permissions : {
				only : ROLE_TYPE.codes()
			}
		}
	}).state('home.planSamplingLine', {
		url : '/planSampling/:idPlan/line',
		templateUrl : "views/sampl/planSampling.line/planSampling.line.html",
		controller : 'planSamplingLineCtrl',
		resolve : {
			planDataResolve : function(planSamplingService, $stateParams) {
				return planSamplingService.getLinePlanSampling($stateParams.idPlan);
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code, ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.sampleInterpret', {
		url : '/sample/interpret',
		template : "<div ui-view></div>",
		controller : "sampleInterpretSelectCtrl",
		data : {
			permissions : {
				only : [ ROLE_TYPE.TECHNICAL_PROFESSIONAL.code ]
			}
		}
	}).state('home.sampleInterpret.select', {
		url : '/select',
		templateUrl : "views/sampl/sample.interpret/sample.interpret.select.html",
		data : {
			permissions : {
				only : [ ROLE_TYPE.TECHNICAL_PROFESSIONAL.code ]
			}
		}
	}).state('home.sampleInterpret.wizard', {
		url : '/wizard',
		templateUrl : "views/sampl/sample.interpret/sample.interpret.wizard.html",
		controller : "sampleInterpretWizardCtrl",
		resolve : {
			urlSampleDetail : function() {
				return 'home.sampleInterpret.wizard.samples'
			}
		},
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.TECHNICAL_PROFESSIONAL.code ]
			}
		}
	}).state('home.sampleInterpret.wizard.sample', {
		url : '/sample',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.header.html"
			},
			'visitInfo@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.interpret/sample.interpret.visitInfo.html"
			},
			'planSampling@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.planSampling.html"
			},
			'takeInfo@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'analysisResult@home.sampleInterpret.wizard.sample' : {
				templateUrl : "views/sampl/sample.interpret/sample.interpret.analysisResults.html"
			}
		},
		params : {
			idPlan : null,
			idSampling : null,
			idSample : null
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams) {
				if (!$stateParams.idSample)
					return null;
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'planSampling',
					name : 'Plan de Muestreo'
				}, {
					href : 'visitInfo',
					name : 'Datos visita'
				}, {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Interpretar'
				} ];
			},
			stepsResolve : function() {
				return [ {
					name : SAMPLE_STATE.SCHEDULED.name,
					index : 0
				}, {
					name : SAMPLE_STATE.ASIGNED.name,
					index : 1
				}, {
					name : SAMPLE_STATE.TAKEN.name,
					index : 2
				}, {
					name : SAMPLE_STATE.ADMITED.name,
					index : 3
				}, {
					name : SAMPLE_STATE.ANALYZING.name,
					index : 4
				}, {
					name : SAMPLE_STATE.ANALYZED.name,
					index : 5
				} ]
			},
			showAnalysisResultsResolve : function() {
				return true;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.TECHNICAL_PROFESSIONAL.code ]
			}
		}
	}).state('home.sampleAll', {
		url : '/sampleAll?sampleId&idClient&states&page&start&end&userid&site&area&idplan',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home.detail/sample.home.detail.html",
				controller : 'sampleAllCtrl',
			},
			'filters@home.sampleAll' : {
				templateUrl : "views/sampl/sample.all/sample.all.filter.html",
				controller : 'sampleAllFilterCtrl'
			},
			'list@home.sampleAll' : {
				templateUrl : "views/sampl/sample.all/sample.all.list.html",
			}
		},
		resolve : {
			urlSampleDetail : function() {
				return 'home.sampleAll.sample'
			}
		},
		reloadOnSearch : false,
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			},
			
			title: 'Información de muestras'
		}
	}).state('home.sampleAll.sample', {
		url : '/sample',
		views : {
			'' : {
				templateUrl : "views/sampl/sample.home/sample.home.html",
				controller : 'sampleHomeCtrl',
				controllerAs : 'ctrl',
			},
			'header@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.header.html"
			},
			'sampleState@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.sampleState.html"
			},
			'nonConforming@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.nonConforming.html"
			},
			'planSampling@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.planSampling.html"
			},
			'visitInfo@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.visitInfo.html"
			},
			'schedule@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.scheduling.html"
			},
			'sampleElements@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.task/sample.task.samplingElements.html",
				controller : 'sampleTaskElementCtrl',
				controllerAs : 'ctrlEl',
			},
			'takeInfo@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.takeInfo.html"
			},
			'admitInfo@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.home/sample.home.admitInfo.html"
			},
			'takeForm@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.task/sample.task.takeInfo.html",
				controller : 'sampleTaskTakeFormCtrl',
				controllerAs : 'ctrlTk',
			},
			'analysisResult@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.analyze/sample.analyze.analysisResults.html",
				controller : 'sampleAnalysisResultCtrl',
				controllerAs : 'ctrlAR'
			},
			'admidForm@home.sampleAll.sample' : {
				templateUrl : "views/sampl/sample.receive/sample.receive.takeForm.html",
				controller : 'sampleReceiveTakeFormCtrl',
				controllerAs : 'ctrlTk',
			}
		},
		params : {
			idPlan : null,
			idSampling : null,
			idSample : null
		},
		resolve : {
			sampleDataResolve : function(planSamplingService, $stateParams, $timeout) {
				if (!$stateParams.idSample)
					return null;
				return planSamplingService.getSample($stateParams.idPlan, $stateParams.idSampling, $stateParams.idSample);
			},
			navigationResolve : function() {
				return [ {
					href : 'planSampling',
					name : 'Plan de Muestreo'
				}, {
					href : 'visitInfo',
					name : 'Datos visita'
				}, {
					href : 'schedule',
					name : 'Programación'
				}, {
					href : 'take',
					name : 'Toma'
				}, {
					href : 'samplingAnalysis',
					name : 'Análisis'
				} ];
			},
			stepsResolve : function(sampleDataResolve) {
				var states = [ {
					name : SAMPLE_STATE.SCHEDULED.name,
					index : 0
				}, {
					name : SAMPLE_STATE.ASIGNED.name,
					index : 1
				}, {
					name : SAMPLE_STATE.TAKEN.name,
					index : 2
				}, {
					name : SAMPLE_STATE.ADMITED.name,
					index : 3
				}, {
					name : SAMPLE_STATE.ANALYZED.name,
					index : 4
				}, {
					name : SAMPLE_STATE.REPORTED.name,
					index : 5
				} ];

				if (sampleDataResolve != null && angular.isDefined(sampleDataResolve)) {
					if (sampleDataResolve.getData().state == SAMPLE_STATE.ANALYZING.enumName) {
						states[4].name = SAMPLE_STATE.ANALYZING.name;
					}
				}

				return states;
			},
			showAnalysisResultsResolve : function() {
				return true;
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			},
			
			title: 'Información de muestras'
		}
	}).state('home.sampleExport', {
		url : '/export',
		templateUrl : "views/sampl/sample.export.html",
		controller: "sampleExportCtrl",
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	});
}